<template>
  <div class="main-wrapper" :class="!minibar ? '' : 'mini-sidebar'">
  	 <Header />
    <Sidebar />
    <div class="page-wrapper">
      <div class="container-fluid">
    	   <router-view />
      </div>   
	</div>   
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";  
import Header from "../components/Dashboard/Topbar";
import Sidebar from "../components/Dashboard/Sidebar";	
export default {
  computed: {
    ...mapState({
       minibar: state => state.minibar
    })
  },
	components: {
   		Header,
    	Sidebar
  	},
	 name: "dashboard",
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/layout/Dashboard.vue